// web/src/console/UserLink.tsx
import type { JSX } from "react";
import { useNavigate } from "react-router-dom";

export function UserLink({ userId, username }: { userId: string | null; username: string | null }): JSX.Element {
  const navigate = useNavigate();
  const label = username ?? userId ?? "—";
  if (userId === null) return <span>{label}</span>;
  return <button className="cc-link" onClick={() => navigate(`/admin/users/${encodeURIComponent(userId)}`)}>{label}</button>;
}
